
import { Stack } from '@fluentui/react';
import { FluentProvider, webLightTheme, SkeletonItem } from '@fluentui/react-components';
import { skeleton3, skeleton5, signFormPosition, dashboardTheme } from '../../styles/customStyles';

export const SkeletonPasswordReset = () => {
  return (
    <>
      <FluentProvider theme={dashboardTheme}>
        <Stack tokens={{ childrenGap: 15 }} style={signFormPosition}>
          <SkeletonItem size={32} style={skeleton3} />
          <SkeletonItem size={32} style={skeleton3} />
          <SkeletonItem size={28} style={skeleton5} />
          <SkeletonItem size={32} style={skeleton3} />
          <SkeletonItem size={28} style={skeleton5} />
        </Stack>
      </FluentProvider>
    </>
  );
};